export class FormVerificationTexts {
    public static titles =  {
        HEADER: "Verification",
        ID: "Upload a government issued ID: Driver License, State ID, Passport or US Visa in JPEG/PNG format",
        CONTACT_DESKPASS: "A Deskpass contact could speed up the process",
        CONTACT: "A workspace contact could help speed up the process",
        LEASE_AGREEMENT: "Upload your signed lease. PDF format only",
        AGREEMENT_TEXT: "Do you have a copy of a signed lease/membership agreement?",
        AGREEMENT_TEXT_QUICK_APPLICATION: "Do you have a copy of your office lease?",
        SSN: "Social security number",
        SSN_ERROR: "Must be 9 digits length"
    };
    public static  placeHolders =  {
        CONTACT: "Enter workspace contact email..."
    }
    public static  propertyNames = {
        MEMBERSHIP: "hasMembership",
        CONTACT: "contactEmail",
        LENDIO_ID: "lendioId",
        LENDIO_PDF: "lendioPdf",
        SIGNUP_PDF: "signupPdfFile",
        IMAGE_ID: "idImage",
        LEAD_SSN: "leadSSN"
    }
}



// WEBPACK FOOTER //
// ./src/scenes/Forms/screens/SignUpForm/FormVerification/FormVerificationTexts.ts